module.exports = __webpack_public_path__ + "static/media/Lekton-Regular.37521aea.ttf";